<template>
  <div class="app-container">
    <CrudTable entity="ShipmentListType" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'name',
        {
          field: 'transportCompanyName',
          label: 'transport.transportCompany',
          sortable: true,
          filter: { type: 'none' }
        },
        {
          field: 'parcelTypeDescriptions',
          label: 'transport.parcelTypes',
          sortable: false,
          filter: { type: 'none' }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
